import styled from 'styled-components';

export const Wrapper = styled.div``;

export const Login = styled.div`
  height: 100vh;
  overflow: hidden;
  @media (max-width: ${({ theme }) => theme.media.md}) {
    flex-direction: column;
    height: 100% !important;
  }
`;

export const LoginLeftBox = styled.div`
  flex: 0 0 45%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  color: ${({ theme }) => theme.palette.white};
  text-align: center;
`;
export const LoginImageBox = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: end;

  @media (max-width: ${({ theme }) => theme.media.md}) {
    padding: 13em 0px 0px;
  }
`;
export const linerGradiant = styled.div`
  @media (max-width: ${({ theme }) => theme.media.md}) {
    background: linear-gradient(0deg,#0000008a,transparent 20%);
  }
`;
export const LoginTitleLeft = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.x3};
`;

export const LoginTitleSecond = styled.div`
  margin: ${({ theme }) => theme.spacing.x10} 0;
  font-size: ${({ theme }) => theme.fs.lg};
  font-weight: 300;
  color: ${({ theme }) => theme.palette.white};
`;

export const LoginImageLink = styled.div`
  margin-top: auto;
  color: ${({ theme }) => theme.palette.white};
`;

export const LanguageSwitcher = styled.div`
  margin: ${({ theme }) => theme.spacing.x3} 0;
`;
